export default __webpack_public_path__ + "static/media/GroupCVV -4.3b9da653.png";